function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M30 0a2 2 0 00-2 2v10.92l-2 1.34V2a2 2 0 10-4 0v12.26l-2-1.34V2a2 2 0 10-4 0v12a1.999 1.999 0 00.9 1.66l5.1 3.42V38a2 2 0 004 0V19.08l5.1-3.42A2 2 0 0032 14V2a2 2 0 00-2-2zM10 0A10 10 0 000 10v12a2 2 0 002 2h6v14a2 2 0 004 0V2a2 2 0 00-2-2zM8 20H4V10a6 6 0 014-5.66V20z"
});

function SvgNewOrderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 40",
    fill: "none"
  }, props), _ref);
}

export default SvgNewOrderIcon;